import KeyRentalFactsContainer from './KeyRentalFactsContainer';

export default KeyRentalFactsContainer;
